import React from 'react';

import clsx from 'clsx';
import { getColorType } from 'PDF/helpers/documentStyle';

import { ProcessTimeline } from './ProcessTimeline';
import { Bookmark } from '../Timeline/Bookmark';
import { IEvent } from '../Timeline/VerticalTimeline';

interface IProcessStagesProps {
  data: IEvent[];
}

export const ProcessStages: React.FC<IProcessStagesProps> = ({ data }) => (
  <div className={clsx('container', 'process-timeline-wrapper', 'timeline-wrapper', getColorType())}>
    <ProcessTimeline className="my-vertical-progress">
      {data.map((item, index) => (
        <Bookmark
          key={index}
          className={
            index === data.length - 1
              ? (index + 1) % 2 == 1
                ? 'last-timeline-item-odd'
                : 'last-timeline-item-even'
              : ''
          }
        >
          <h1 className="date">{item.step}</h1>
          <p className="description">{item.title}</p>
        </Bookmark>
      ))}
    </ProcessTimeline>
  </div>
);
